module.exports = __webpack_public_path__ + "img/introduce05_left01.e6cb4983.png";